class gaBridge {
  logEvent(category, action, label) {
    if (window.ga !== undefined) {
      window.ga('create', 'UA-124196431-3', 'auto');
      window.ga('send', 'event', category, action, label);
    }
  }
}

export default new gaBridge();
